if ($('.js-promo-block-captions').length > 0) {
    $('.js-promo-block-captions .caption').matchHeight();
}

if ($('.js-promo-block').length > 0) {
    /**
     * Promo block expanded information
     */
    $('.js-promo-block .more').on('click', function(event) {

        event.preventDefault();

        var $promoBlock = $(this).closest('.js-promo-block');
        var $promoBlockDataId = $promoBlock.data('promo-block');
        var $promoBlockExpandedInformation = $('.js-expanded-information[data-promo-block="' + $promoBlockDataId + '"]');

        if ($promoBlockExpandedInformation.length !== 0) {
            $(this).addClass('invisible');
            $promoBlock.addClass('active');
            $promoBlockExpandedInformation.slideDown();
        }

    });

    /**
     * Expanded information dismiss
     */
    $('.js-expanded-information .js-close').on('click', function(event) {

        event.preventDefault();

        var $expandedInformation = $(this).closest('.js-expanded-information');

        var $promoBlockDataId = $expandedInformation.data('promo-block');
        var $promoBlock = $('.js-promo-block[data-promo-block="' + $promoBlockDataId + '"]');
        var $moreLink = $promoBlock.find('.more');

        $expandedInformation.slideUp('fast', function() {
            $promoBlock.removeClass('active');
            $moreLink.removeClass('invisible');
        });

    });
}
